<!-- eslint-disable vue/multi-word-component-names -->

<template>
  <!-- 
  404 error page -------------------

  <section class="error">
    <h6>404 error</h6>
    <p class="detail">
      <span>죄송합니다. 페이지를 찾을 수 없습니다.</span>
      <span>존재하지 않는 주소를 입력하셨거나,</span>
      <span>요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.</span>
    </p>     
  </section>  
  
  -->
  <!-- S: main banner -->
  <section class="main_wrap">
    <video class="main-video main-video_web" id="main-video" autoplay muted loop playsinline>
      <source src="@/assets/video/main_vd_dark_sm.mp4" type="video/mp4" />
    </video>
    <video class="main-video main-video_mobile" id="main-video-mobile" autoplay muted loop playsinline>
      <source src="@/assets/video/main_mobile_sm.mp4" type="video/mp4" />
    </video>
    <div class="visual_title">
      <h2 class="comment-en" data-aos="fade-up" data-aos-duration="2200">
        <span>{{ $t("HOME.0001") }}</span>
        <span>{{ $t("HOME.0002") }}</span>
      </h2>
      <h2 class="comment" data-aos="fade-up" data-aos-duration="2000">
        <span v-html="$t('HOME.0003')"></span>
      </h2>
    </div>
    <div class="scroll_wrap">
      <div class="down">
        <div class="mouse">
          <div class="circle"></div>
        </div>
        <p class="txt">{{ $t("HOME.0006") }}</p>
        <div class="arrow"></div>
      </div>
    </div>
  </section>
  <!-- E: main banner -->
  <!-- S: text loop -->
  <div class="flow_banner">
    <ul class="list">
      <!-- <li>{{ $t("HOME.0007") }}</li>
      <li>{{ $t("HOME.0008") }}</li>
      <li>{{ $t("HOME.0009") }}</li>
      <li>{{ $t("HOME.0010") }}</li>
      <li>{{ $t("HOME.0011") }}</li>
      <li>{{ $t("HOME.0012") }}</li>
      <li>{{ $t("HOME.0013") }}</li>
      <li>{{ $t("HOME.0014") }}</li>
      <li>{{ $t("HOME.0015") }}</li>
      <li>{{ $t("HOME.0016") }}</li>
      <li>{{ $t("HOME.0017") }}</li> -->
      <!-- 2025/08/04 추가 -->
      <li>DX</li>
      <li>AX</li>
      <li>Generative AI</li>
      <li>Chatbot</li>
      <li>Cloud</li>
      <li>LLM</li>
      <li>CONSULTING</li>
      <li>ANDROID</li>
      <li>SOLUTION</li>
      <li>iOS</li>
      <li>DESIGN</li>
      <li>WINDOWS</li>
      <li>BUILDING</li>
      <li>WEBFORM</li>
      <li>MVC</li>
      <li>WINFORM</li>
      <li>XALM</li>
    </ul>
  </div>
  <!-- E: text loop -->
  <!-- S: intro -->
  <section class="intro">
    <div class="cont">
      <div class="title_wrap" data-aos="fade-up" data-aos-duration="1000">
        <div class="title">
          <h3>
            <span v-html="$t('HOME.0018')"></span>
          </h3>
        </div>
        <div class="sub">
          <span v-html="$t('HOME.0021')"></span>
        </div>
      </div>
      <div class="bg_props">
        <svg width="1520" height="304" viewBox="0 0 1520 304" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M226.718 304.635H19.0002C19.0002 189.916 111.998 96.9177 226.718 96.9177V304.635Z" fill="#64AAF9" />
          <path d="M226.532 6.67963H434.25C434.25 121.399 341.252 214.397 226.532 214.397V6.67963Z" fill="#98E0ED" />
          <path
            d="M482.047 304.635C424.681 304.635 378.188 258.143 378.188 200.777C378.188 143.423 424.681 96.9177 482.047 96.9177C539.413 96.9177 585.906 143.423 585.906 200.777C585.906 258.143 539.4 304.635 482.047 304.635Z"
            fill="#F8C7D3" />
          <path
            d="M1106.38 115.548C1079.27 115.548 1057.29 93.5718 1057.29 66.456C1057.29 39.3464 1079.27 17.3643 1106.38 17.3643C1133.5 17.3643 1155.47 39.3464 1155.47 66.456C1155.47 93.5718 1133.49 115.548 1106.38 115.548Z"
            fill="#64AAF9" />
          <path
            d="M1399.24 304.635C1341.88 304.635 1295.39 258.143 1295.39 200.777C1295.39 143.41 1341.89 96.9177 1399.24 96.9177C1456.6 96.9177 1503.1 143.423 1503.1 200.777C1503.1 258.13 1456.6 304.635 1399.24 304.635Z"
            fill="#FFC6BA" />
          <path d="M1295.28 304.635H1087.56C1087.56 189.916 1180.56 96.9177 1295.28 96.9177V304.635Z" fill="#5189E3" />
          <path d="M843.637 304.635H635.92C635.92 189.916 728.918 96.9177 843.637 96.9177V304.635Z" fill="#5189E3" />
          <path d="M1051.35 304.635H843.637V96.9177C958.357 96.9177 1051.35 189.916 1051.35 304.635Z" fill="#2A4A96" />
          <path
            d="M1051.29 214.452C1051.46 214.828 1051.91 214.994 1052.28 214.822C1052.66 214.65 1052.83 214.205 1052.65 213.829L1051.29 214.452ZM641.106 205.444C659.16 164.721 724.91 83.1606 843.332 83.1606V81.6606C724.151 81.6606 657.954 163.74 639.734 204.836L641.106 205.444ZM843.332 83.1606C961.735 83.1606 1031.32 170.697 1051.29 214.452L1052.65 213.829C1032.54 169.764 962.534 81.6606 843.332 81.6606V83.1606Z"
            fill="#84D0F6" />
          <path class="active_line" d="M1 307.006C2.09093 232.413 53.7736 81.5928 226.413 81.5928" stroke="#84D0F6"
            stroke-width="1.5" stroke-linecap="round" />
          <path class="active_line"
            d="M1399.63 82.4456C1465.16 82.4456 1518.26 135.554 1518.26 201.084C1518.26 266.599 1465.14 319.722 1399.63 319.722"
            stroke="#84D0F6" stroke-width="1.5" />
          <path class="active_line"
            d="M1040.93 66.4557C1040.93 102.61 1070.23 131.911 1106.38 131.911C1142.53 131.911 1171.84 102.61 1171.84 66.4557C1171.84 30.3095 1142.54 1 1106.38 1C1103.05 1 1099.77 1.2497 1096.56 1.73142"
            stroke="#84D0F6" stroke-width="1.5" />
        </svg>
      </div>
    </div>
  </section>
  <!-- E: intro -->

  <section class="mini_field">
    <h2 class="tt_hidden">{{ $t("HOME.0024") }}</h2>
    <!-- S: intro video -->
    <article class="intro_video">
      <div class="cont">
        <h3 class="title">
          <span>{{ $t("HOME.0025") }}</span>
          <span>{{ $t("HOME.0026") }}</span>
        </h3>
        <p>{{ $t("HOME.0027") }}</p>
      </div>
      <div class="video_m">
        <iframe width="1280" height="720" src="https://www.youtube.com/embed/hgWZTOss5mU?amp;autoplay=1"
          v-bind:title='$t("HOME.0087")'
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="wrapper">
        <input type="checkbox" aria-label="View Video" />
        <div class="video">
          <iframe allowfullscreen width="1280" height="720"
            src="https://www.youtube.com/embed/hgWZTOss5mU;?autoplay=1&mute=1&amp;loop=1" v-bind:title='$t("HOME.0087")'
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        </div>
        <div class="text">
          <span data-text="play"></span>
        </div>
      </div>
    </article>
    <!-- E: intro video -->

    <!-- S: our business -->
    <article class="mini_business" data-aos="fade-up" data-aos-duration="1000">
      <div class="title_wrap">
        <div class="title">
          <h4 class="tt_en">
            <span>{{ $t("HOME.0028") }}</span>
            <span>{{ $t("HOME.0029") }}</span>
          </h4>
          <h4 class="tt_kr">{{ $t("HOME.0030") }}</h4>
        </div>
        <div class="txt">
          <span v-html="$t('HOME.0031')"></span>
        </div>
      </div>
      <div class="cont_wrap">
        <div class="list">
          <!-- 2025/08/04추가 -->
          <div class="bs_item">
              <div class="bs_img bs_img-ax">
                  <h5>AX</h5>
                  <div class="btn_go">
                      <RouterLink :to="{path:'/business', hash:'#mBusiAx'}">
                        <div class="bg"></div>
                        <span class="txt">자세히보기</span>
                      </RouterLink>
                  </div>
              </div>
              <p>AI Transformation</p>
          </div>

          <div class="bs_item">
            <div class="bs_img bs_img-si">
              <h5>{{ $t("HEADER.0022") }}</h5>
              <div class="btn_go">
                <RouterLink :to="{path:'/business', hash:'#mBusiSi'}">
                  <span class="txt">{{ $t("HOME.0035") }}</span>
                </RouterLink>
              </div>
            </div>
            <p>{{ $t("HEADER.0010") }}</p>
          </div>
          
        </div>
        <div class="list">
          <!-- <div class="bs_item">
            <div class="bs_img bs_img-sk">
              <h5>{{ $t("HEADER.0012") }}</h5>
              <div class="btn_go">
                <RouterLink :to="{path:'/business', hash:'#mBusiSmk'}">
                  <div class="bg"></div>
                  <span class="txt">{{ $t("HOME.0035") }}</span>
                </RouterLink>
              </div>
            </div>
            <p>{{ $t("HOME.0036") }}</p>
          </div> -->
          <div class="bs_item">
            <div class="bs_img bs_img-iot">
              <h5>{{ $t("HEADER.0023") }}</h5>
              <div class="btn_go">
                <RouterLink :to="{path:'/business', hash:'#mBusiIot'}">
                  <div class="bg"></div>
                  <span class="txt">{{ $t("HOME.0035") }}</span>
                </RouterLink>
              </div>
            </div>
            <p>{{ $t("HEADER.0011") }}</p>
          </div>
          <div class="bs_item">
            <div class="bs_img bs_img-dwx">
              <h5>{{ $t("HOME.0037") }}</h5>
              <div class="btn_go">
                <a href="/solution">
                  <div class="bg"></div>
                  <span class="txt">{{ $t("HOME.0035") }}</span>
                </a>
              </div>
            </div>
            <p>{{ $t("HOME.0037") }}</p>
          </div>
        </div>
      </div>
    </article>
    <!-- E: our business -->
    <!-- S: business platform -->
    <!-- <article class="mini_platform" data-aos="fade-up" data-aos-duration="1000">
      <div class="title_wrap">
        <div class="title">
          <h4 class="tt_en">
            <span>{{ $t("HOME.0038") }}</span>
          </h4>
          <h4 class="tt_kr">{{ $t("HOME.0039") }}</h4>
        </div>
      </div>
      <div class="cont_wrap">
        <div class="pf_item">
          <div class="pf_img pf_img-ecowaste">
            <a href="https://www.ecowaste.co.kr/" target="_blank">
              <h5 class="pf_logo pf_logo-ecowaste">
                <span>{{ $t("HOME.0040") }}</span>
              </h5>
            </a>
          </div>
          <div class="pf_detail pf_detail-ecowaste">
            <div class="tt">
              <h5>{{ $t("HOME.0041") }}</h5>
              <p>{{ $t("HOME.0042") }}</p>
            </div>
            <p class="txt">
              <span v-html="$t('HOME.0043')"></span>
            </p>
          </div>
        </div>
        <div class="pf_item">
          <div class="pf_img pf_img-minibot">
            <a href="https://minibot.kr/" target="_blank">
              <h5 class="pf_logo pf_logo-minibot">
                <span>{{ $t("HOME.0045") }}</span>
              </h5>
            </a>
          </div>
          <div class="pf_detail pf_detail-minibot">
            <div class="tt">
              <h5>{{ $t("HOME.0046") }}</h5>
              <p>{{ $t("HOME.0047") }}</p>
            </div>
            <p class="txt">
              <span v-html="$t('HOME.0048')"></span>
            </p>
          </div>
        </div>
      </div>
    </article> -->
    <!-- E: business platform -->
    <!-- S: vision -->
    <article class="vision">
      <div class="title_wrap">
        <div class="title">
          <h4 class="tt_en">
            <span>{{ $t("HOME.0050") }}</span>
          </h4>
          <h4 class="tt_kr">{{ $t("HOME.0051") }}</h4>
        </div>
      </div>
      <div class="cont_wrap">
        <video class="vs-video" autoplay loop muted playsinline src="@/assets/video/vision_vd.mp4"></video>
        <div class="bg-gradient"></div>
        <div class="contents" data-aos="fade-up" data-aos-duration="1000">
          <h3 class="vs_tt">
            <span>{{ $t("HOME.0052") }}</span>
            <span>{{ $t("HOME.0053") }}</span>
          </h3>
          <ul class="vs_list">
            <li data-aos="zoom-in" data-aos-duration="1200">
              <svg class="vs_symbol vs_symbol-first" width="200" height="100" viewBox="0 0 200 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path class="one"
                  d="M107 50C107 71.5391 89.5391 89 68 89C46.4609 89 29 71.5391 29 50C29 28.4609 46.4609 11 68 11C89.5391 11 107 28.4609 107 50Z"
                  stroke="white" stroke-width="2" />
                <path class="two"
                  d="M171.242 50C171.242 71.5391 153.782 89 132.242 89C110.703 89 93.2424 71.5391 93.2424 50C93.2424 28.4609 110.703 11 132.242 11C153.782 11 171.242 28.4609 171.242 50Z"
                  stroke="white" stroke-width="2" />
              </svg>
              <p class="sb_tt">{{ $t("HOME.0054") }}</p>
              <p class="sb_txt">
                <span v-html="$t('HOME.0055')"></span>
              </p>
            </li>
            <li data-aos="zoom-in" data-aos-duration="1500">
              <svg class="vs_symbol vs_symbol-second" width="200" height="100" viewBox="0 0 200 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M99.5591 9V92" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M76.3481 15.8562L108.985 91.5118" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M60.6472 32.8568L118.017 87.4555" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M57 53.2892L127.723 81.791" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M122.741 15.8562L90.1038 91.5118" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M138.442 32.8568L81.0652 87.4555" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M142.082 53.2892L71.3586 81.791" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                <path d="M136.174 70.5985H62.9446" stroke="white" stroke-width="2" stroke-miterlimit="10" />
              </svg>
              <p class="sb_tt">{{ $t("HOME.0057") }}</p>
              <p class="sb_txt">
                <span v-html="$t('HOME.0058')"></span>
              </p>
            </li>
            <li data-aos="zoom-in" data-aos-duration="1800">
              <svg class="vs_symbol vs_symbol-third" width="200" height="100" viewBox="0 0 200 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path class="one"
                  d="M80 50C80 71.5391 62.5391 89 41 89C19.4609 89 2 71.5391 2 50C2 28.4609 19.4609 11 41 11C62.5391 11 80 28.4609 80 50Z"
                  stroke="white" stroke-width="2" />
                <path class="two"
                  d="M147.876 50C147.876 71.2134 130.962 88.4574 109.879 88.9874V11.0126C130.962 11.5426 147.876 28.7866 147.876 50Z"
                  stroke="white" stroke-width="2" />
                <path class="three"
                  d="M197.421 50C197.421 71.2134 180.508 88.4574 159.424 88.9874V11.0126C180.508 11.5426 197.421 28.7866 197.421 50Z"
                  stroke="white" stroke-width="2" />
              </svg>
              <p class="sb_tt">{{ $t("HOME.0060") }}</p>
              <p class="sb_txt">
                <span v-html="$t('HOME.0061')"></span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </article>
    <!-- E: vision -->
  </section>

  <!-- S: news -->
  <section class="news">
    <h2 class="tt_hidden">{{ $t("HOME.0063") }}</h2>
    <article>
      <div class="title_wrap">
        <div class="title">
          <h4 class="tt_en">
            <span>{{ $t("HOME.0064") }}</span>
          </h4>
          <h4 class="tt_kr">{{ $t("HOME.0065") }}</h4>
        </div>
      </div>
      <carousel class="news_list" :wrap-around="true" :breakpoints="newsbreakpoints" :autoplay="2600">
        <!-- 2025/08/04 추가 -->
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://www.etnews.com/20250730000128" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">“AI로 기업의 지식을 깨우다”...미니소프트, 도메인 특화 AI 챗봇 빌더 '루미너스’ 출시</strong>
              <p class="txt">
                IT 전문기업 미니소프트(대표 이윤복)가 기업 업무 환경에 최적화된 
                AI 챗봇 빌더 솔루션 '루미너스(LUMINUS)'를 출시했다고 31일 밝혔다.
                루미너스는 RAG(Retrieval-Augmented Generation) 및 MCP(Model Context Protocol) 기술을 
                기반으로 기업이 보유한 지식 자산과 업무 시스템을 연결하고, 
                이를 AI 응답에 실시간 반영할 수 있도록 지원한다.
              </p>
            </div>
            <div class="card_date">2025.07.31</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="http://www.koscaj.com/news/articleView.html?idxno=229725" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0066") }}</strong>
              <p class="txt">
                {{ $t("HOME.0067") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0068") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://kookbang.dema.mil.kr/newsWeb/20220421/5/BBSMSTR_000000010023/view.do" target="_blank"
            class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0069") }}</strong>
              <p class="txt">
                {{ $t("HOME.0070") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0071") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://www.sisamagazine.co.kr/news/articleView.html?idxno=364013" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0072") }}</strong>
              <p class="txt">
                {{ $t("HOME.0073") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0074") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="http://www.mdtoday.co.kr/mdtoday/index.html?no=421078" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0075") }}</strong>
              <p class="txt">
                {{ $t("HOME.0076") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0077") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://www.breaknews.com/851932" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0078") }}</strong>
              <p class="txt">
                {{ $t("HOME.0079") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0080") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://www.thedailypost.kr/news/articleView.html?idxno=81943" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0081") }}</strong>
              <p class="txt">
                {{ $t("HOME.0082") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0083") }}</div>
          </a>
        </slide>
        <slide class="news_box" v-on:mouseenter="newsMouseEnter" v-on:mouseleave="newsMouseLeave">
          <a href="https://www.thedailypost.kr/news/articleView.html?idxno=79052" target="_blank" class="box_item">
            <div class="cont">
              <strong class="title">{{ $t("HOME.0084") }}</strong>
              <p class="txt">
                {{ $t("HOME.0085") }}
              </p>
            </div>
            <div class="card_date">{{ $t("HOME.0086") }}</div>
          </a>
        </slide>
        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </carousel>
    </article>
  </section>
  <!-- E: news -->
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data: () => ({
    newsbreakpoints: {
      // 700px and up
      300: {
        itemsToShow: 1,
      },
      // 1024 and up
      820: {
        itemsToShow: 2.5,
      },
      1420: {
        itemsToShow: 3.5,
      },
    },
  }),
  methods: {
    newsMouseEnter: function (e) {
      e.target.querySelector("a").classList.add("box_item_active");
    },
    newsMouseLeave: function (e) {
      e.target.querySelector("a").classList.remove("box_item_active");
    },

    setFlowBanner: function () {
      const wrap = document.querySelector(".flow_banner");
      const list = document.querySelector(".flow_banner .list");
      let wrapWidth = ""; //$wrap의 가로 크기
      let listWidth = ""; //$list의 가로 크기
      const speed = 92; //1초에 몇픽셀 이동하는지 설정

      //리스트 복제
      const clone = list.cloneNode(true);
      wrap.appendChild(clone);
      flowBannerAct();

      //반응형 :: 디바이스가 변경 될 때마다 배너 롤링 초기화
      let oldWChk =
        window.innerWidth > 1279 ? "pc" : window.innerWidth > 767 ? "ta" : "mo";
      window.addEventListener("resize", function () {
        let newWChk =
          window.innerWidth > 1279
            ? "pc"
            : window.innerWidth > 767
              ? "ta"
              : "mo";
        if (newWChk != oldWChk) {
          oldWChk = newWChk;
          flowBannerAct();
        }
      });

      //배너 실행 함수
      function flowBannerAct() {
        //배너 롤링 초기화
        if (wrapWidth != "") {
          const listElements = wrap.querySelectorAll(".list");
          listElements.forEach((element, index) => {
            if (index > 1) {
              element.remove();
            } else {
              element.style.animation = "none";
            }
          });
        }
        wrapWidth = wrap.offsetWidth;
        listWidth = list.offsetWidth;

        //무한 반복을 위해 리스트를 복제 후 배너에 추가
        if (listWidth < wrapWidth) {
          const listCount = Math.ceil((wrapWidth * 2) / listWidth);
          for (let i = 2; i < listCount; i++) {
            const newClone = clone.cloneNode(true);
            wrap.appendChild(newClone);
          }
        }

        const listElements = wrap.querySelectorAll(".list");
        listElements.forEach((element) => {
          element.style.animation = `${listWidth / speed
            }s linear infinite flowRolling`;
        });
      }
    },
  },
  mounted() {
    this.setFlowBanner();
  },
};
</script>

<style scoped></style>